import ConstValues from 'utils/const';

const st = ConstValues.searchTypes;

/**
 * stores/StoreUtils.js implements a suite of common functions within a `StoreUtils` class and
 * these functions can be shared among multiple stores
 * @deprecated this causes all sorts of strange import problems. Do not use this in new code.
 */
class Utils {
  searchResultsWithCustomContentData(searchResults, data) {
    const results = searchResults.results.map(result =>
      result.id !== data.id
        ? result
        : result.merge({
            fields: {
              ...result.fields,
              Company: data.company,
              Contact: data.contact,
              'CRM Link': data.crm_link,
            },
            custom_content: data.custom_content,
          })
    );
    return searchResults.merge({results});
  }

  /**
   * Return a search-type menuItem's primaryText given a search field
   * @param searchField {Field} Search field whose name should map to a menuItem's primary text
   */
  menuItemPrimaryTextFromSearchField(searchField) {
    switch (searchField.name) {
      case 'Caller':
        return st.miCaller;
      case 'Contact':
        return st.miContact;
      case 'Phone':
        return st.miPhone;
      case 'Company':
        return st.miCompany;
      case 'Call Stage':
        return st.miCallStage;
      case 'Campaign':
        return st.miCampaign;
      case 'Keyword / Topic':
        return st.miKeywords;
      case 'Comments':
        return st.miAnnotations;
      case 'Tags':
        return st.miAnnotations;
      default:
        break;
    }
    return null;
  }
}

export default Utils;
